<template>
  <div id="app">
    <hy-layout >
      <router-view />
    </hy-layout>
  </div>
</template>

<script>
import HyLayout from './components/global/hy-layout'
import {chkLogin, chkVersion} from './service/util'

export default {
  name: 'App',
  components: {HyLayout},
  created () {
    console.log('App Created')
    chkVersion().then(res => {
      if (res.code === 201) {
        this.$confirm(res.data.message, res.data.version, {
          lockScroll: true,
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: '更新'
        }).then(r => {
          window.location.reload(-1)
        })
      }
    })
    chkLogin().then(res => {
      console.log(res)
    })
  }
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
}
#app {
  font-weight: 400;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color:#1e293b;
  min-height: 100%;
  text-align: center;
  background-color: #e8ecf3;
  min-width: 1180px;
}
#nprogress .bar {
  background: #3264FF !important;
}
.w1180{
  display: inline-block;
  width: 98%;
  max-width: 1180px;
  height: 100%;
  margin: 0 auto;
  text-align: left;
}
.noborder .el-input__inner{
  border: 0 !important;
}
.el-carousel__arrow{
  background-color: rgba(31,45,61,.61);
}

/* 隐藏图片预览器右上角的关闭按钮 */
.el-image-viewer__close {
  display: none !important;
}

/* 统一字体粗细标准 */
.font-normal {
  font-weight: 400 !important; /* 正常文本 */
}

.font-medium {
  font-weight: 500 !important; /* 重要文本，如小标题、重要信息 */
}

.font-semibold {
  font-weight: 600 !important; /* 标题文本，如卡片标题、页面标题 */
}

.font-bold {
  font-weight: 700 !important; /* 强调文本，如价格、警告信息 */
}

/* 覆盖各种元素的默认字体粗细 */
h1, h2, h3, h4, h5, h6 {
  font-weight: 600 !important; /* 统一标题字体粗细 */
}

strong, b {
  font-weight: 700 !important; /* 统一强调元素字体粗细 */
}

.el-button {
  font-weight: 500 !important; /* 统一按钮字体粗细 */
}

.price, .amount {
  font-weight: 700 !important; /* 价格相关文本使用粗体 */
}

.title {
  font-weight: 600 !important; /* 标题类文本 */
}

.subtitle {
  font-weight: 500 !important; /* 副标题类文本 */
}

.label {
  font-weight: 500 !important; /* 标签类文本 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue